import React from 'react';
import PropTypes from 'prop-types';
import createGoogleAnalytics from '../../common/googleAnalytics/eventDispatcher';

class GoogleAnalyticsProvider extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        servicetoolName: PropTypes.string.isRequired,
    };

    static childContextTypes = {
        googleAnalytics: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.googleAnalytics = createGoogleAnalytics(props.servicetoolName);
    }

    getChildContext = () => ({
        googleAnalytics: this.googleAnalytics,
    });

    render() {
        return this.props.children;
    }
}

export default GoogleAnalyticsProvider;



// WEBPACK FOOTER //
// ./src/frontend/components/googleAnalytics/GoogleAnalyticsProvider.jsx